module.exports = __webpack_public_path__ + "static/media/etsy-colordin.b945616d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/etsy-colordin.svg
// module id = 126
// module chunks = 0